import React from 'react';
import { Link } from 'react-router-dom';
import './PageHero.css';

export default function PageHero({ eyebrow, title, subtitle, crumb }) {
  return (
    <div className="page-hero" id="main-content">
      <div className="page-hero-inner">
        <nav className="breadcrumb" aria-label="breadcrumb">
          <Link to="/">Home</Link>
          <span aria-hidden="true">/</span>
          <span>{crumb || eyebrow}</span>
        </nav>
        {eyebrow && <div className="page-eyebrow">{eyebrow}</div>}
        <h1 dangerouslySetInnerHTML={{ __html: title }} />
        {subtitle && <p className="page-hero-sub">{subtitle}</p>}
      </div>
    </div>
  );
}
